import { Box } from '@mui/material';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import Toast from 'components/Toast';
import { fontFamily } from 'material';
import React from 'react';
import type { Store } from 'redux';
import type Types from 'Types';

// RouterContext is injected at router creation time (src/routes/-router.ts)
// and available in beforeLoad/loader hooks across all routes
export interface RouterContext {
  store: Store<Types.RootState>;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

// Root layout — wraps every route with the app shell: global font, full-viewport
// height, and the toast notification outlet. Outlet renders the matched child route.
function RootLayout() {
  return (
    <Box
      component="main"
      sx={{
        fontFamily: fontFamily.INTER,
        width: '100%',
        // css viewport height unit does not respect mobile device viewport change;
        // --vh variable and resize listener is set in global styles
        height: `calc(var(--vh, 1vh) * 100)`,
      }}
    >
      <Toast />
      <Outlet />
    </Box>
  );
}
